// extracted by mini-css-extract-plugin
export default {"container":"Yr-z","heading":"Zr-z","text":"_r-z","info":"as-z","link":"bs-z","fullMaxWidth":"cs-z"};